export const AGENTIC_CHAT_PRODUCT_NAME = 'Flow Compass';
